import { render, staticRenderFns } from "./ReportPopover.vue?vue&type=template&id=c01f3c80&scoped=true&"
import script from "./ReportPopover.vue?vue&type=script&lang=js&"
export * from "./ReportPopover.vue?vue&type=script&lang=js&"
import style0 from "./ReportPopover.vue?vue&type=style&index=0&id=c01f3c80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c01f3c80",
  null
  
)

export default component.exports